<template>
  <section class="panel">
    <header v-if="hasHeader" class="panel__header">
      <slot name="header" />
    </header>
    <main class="panel__body">
      <slot />
    </main>
  </section>
</template>

<script>
  export default {
    computed: {
      hasHeader() {
        return !!this.$slots.header
      },
    },
  }
</script>

<style lang="scss" src="./Panel.scss"></style>
